export const SOCIAL_CONFIRMATION_URL = "/auth/social-confirmation";
export const EMAIL_VERIFICATION_URL = "/auth/email-verification";
export const SELECT_PLAN_URL = "/pricing/select-plan";
export const AUTH_URL = "/pricing/auth";
export const MANAGE_URL = "/manage";
export const AUTH_LOGIN_URL = "/auth/login";
export const AUTH_PASSWORD_RECOVERY = "/auth/password-recovery";